module.exports = __webpack_public_path__ + "img/home-banner.f1f7cc45.jpg";